export const Colors = {
    graphite: '#272727',
    gray: '#969696',
    lightGray: '#d7d7d7',
    border: '#dcdcdc',
    whiteButton: {
        hover: '#F7F7F7',
        active: '#F2F2F2',
    }
}